export default __webpack_public_path__ + "static/media/tiktok-shop.7b26ad6e.svg";